import { Button, FormGroup } from "@mui/material";
import styles from "../../ProductsRPDesigner.module.scss";
import { componentTemplate } from "../../responsePage/rptemplate";

function GSComponents({ addComponent }) {

  return (
    <FormGroup
      data-tour="rpdesigner-step-2"
      className={styles["sec--products--rpdesigner--buttons"]}
    >
      {Object.keys(componentTemplate).map((key) => {
        return (
          <div
            key={key}
            className={styles["sec--products--rpdesigner--formcontrol"]}
          >
            <Button
              id={key}
              fullWidth
              variant="contained"
              color="primary"
              onClick={(e) => addComponent(e.target.name)}
              name={componentTemplate[key].name}
            >
              {componentTemplate[key].label}
            </Button>
          </div>
        );
      })}
    </FormGroup>
  );
}

export default GSComponents;
